import type { FurnitureAgentStepId } from "@/types/furniture-agent";

export const STEP_ORDER: FurnitureAgentStepId[] = [
  "UPLOAD_RECEIVED",
  "IMAGE_PREPROCESS",
  "VISION_PARSE",
  "DIMENSION_EXTRACT",
  "MATERIAL_INFERENCE",
  "UNIT_PRICE_MATCH",
  "QUOTE_COMPOSE",
];

export const STEP_META: Record<
  FurnitureAgentStepId,
  { label: string; icon: string; slaP50Ms: number; slaP95Ms: number; hint: string }
> = {
  UPLOAD_RECEIVED:    { label: "도면 업로드",     icon: "UploadCloud", slaP50Ms:  200, slaP95Ms:  500, hint: "PDF, JPG 등 도면 파일을 수신합니다." },
  PDF_PARSED:         { label: "견적서 결정적 파싱", icon: "AlignLeft", slaP50Ms: 1500, slaP95Ms: 3000, hint: "도면/견적서 표를 오차 없이 추출합니다." },
  IMAGE_PREPROCESS:   { label: "이미지 전처리",   icon: "🖼️", slaP50Ms: 1200, slaP95Ms:  3000, hint: "회전·디스큐·타일링" },
  VISION_PARSE:       { label: "도면 인식",       icon: "👁️", slaP50Ms: 6000, slaP95Ms: 18000, hint: "OCR + Vision LLM" },
  DIMENSION_EXTRACT:  { label: "치수 추출",       icon: "📐", slaP50Ms: 2500, slaP95Ms:  7000, hint: "W/D/H, 수량" },
  MATERIAL_INFERENCE: { label: "마감재 추론",     icon: "🪵", slaP50Ms: 2000, slaP95Ms:  6000, hint: "하드웨어 포함" },
  UNIT_PRICE_MATCH:   { label: "단가 매칭",       icon: "💰", slaP50Ms: 1500, slaP95Ms:  5000, hint: "레퍼런스 93건" },
  QUOTE_COMPOSE:      { label: "견적서 조립",     icon: "🧾", slaP50Ms:  800, slaP95Ms:  2500, hint: "아이템 라인 생성" },
};

export const HUMANIZE_BACKEND_TYPE: Record<string, string> = {
  "SCHEDULE-AUTO-BRIEFING": "견적 자동 분석",
};
